<template lang="html">
  <div class="podcast-analytics__container">
    <TryForFreeSection
      :feature-name="
        $t('pages.ssr_features.pages.podcast_analytics.try_for_free.feature_name')
      "
      :title="$t('pages.ssr_features.pages.podcast_analytics.try_for_free.title')"
      :description="
        $t('pages.ssr_features.pages.podcast_analytics.try_for_free.description')
      "
      image-path="/images/features/podcast_analytics/try_for_free_section_illustration.png"
      :image-alt="
        $t('pages.ssr_features.pages.podcast_analytics.try_for_free.image_alt')
      "
    />
    <CharacteristicsSection
      :icons="['Clock', 'Grid', 'Globe']"
      characteristic-keys="pages.ssr_features.pages.podcast_analytics.characteristics"
    />
    <BulletSection
      :title="$t('pages.ssr_features.pages.podcast_analytics.bullets.title')"
      bullet-keys="pages.ssr_features.pages.podcast_analytics.bullets.items"
      image-path="/images/features/podcast_analytics/bullet_section_illustration.png"
      :image-alt="$t('pages.ssr_features.pages.podcast_analytics.bullets.image_alt')"
    />

    <TextWithImage
      :title="$t('pages.ssr_features.pages.podcast_analytics.text_with_image.title')"
      description-key="pages.ssr_features.pages.podcast_analytics.text_with_image.description"
      image-path="/images/features/podcast_analytics/text_with_image_illustration.png"
    />
    <GridSection
      item-keys="pages.ssr_features.pages.podcast_analytics.grid.items"
      :images-path="[
        '/images/features/podcast_analytics/grid_illustration_1.png',
        '/images/features/podcast_analytics/grid_illustration_2.png',
        '/images/features/podcast_analytics/grid_illustration_3.png',
        '/images/features/podcast_analytics/grid_illustration_4.png'
      ]"
      :description-urls="[
        'https://rss.com/blog/podcast-analytics-grow-monetize/',
        null,
        null,
        null
      ]"
    />
    <HowToStartSection
      :title="$t('pages.ssr_features.pages.podcast_analytics.how_to_start.title')"
      video-url="https://player.vimeo.com/video/1007749175"
    />
    <ReviewsSection
      :reviews="$t('pages.ssr_features.pages.podcast_analytics.reviews.items')"
    />
    <MoveYourPodcastSection />
    <MoreFeaturesSection
      :features="['distribution', 'monetization', 'transcript']"
    />
  </div>
</template>

<script>
import getMeta from '@/lib/meta'
import { schemaMarkup } from '@/lib/schema-markup'

import TryForFreeSection from '@/components/pages/features/common/try-for-free/index'
import CharacteristicsSection from '@/components/pages/features/common/characteristics/index'
import BulletSection from '@/components/pages/features/common/bullet/index'
import TextWithImage from '@/components/pages/features/common/text-with-image/index'
import GridSection from '@/components/pages/features/common/grid/index'
import HowToStartSection from '@/components/pages/features/common/how-to-start/index'
import ReviewsSection from '@/components/pages/features/common/reviews/index'
import MoveYourPodcastSection from '@/components/pages/features/common/move-your-podcast/index'
import MoreFeaturesSection from '@/components/pages/features/common/more-features/index'

export default {
  components: {
    TryForFreeSection,
    CharacteristicsSection,
    BulletSection,
    TextWithImage,
    GridSection,
    ReviewsSection,
    MoveYourPodcastSection,
    MoreFeaturesSection,
    HowToStartSection
  },

  layout: 'landing',

  middleware: ['languageRedirect'],

  head () {
    const resultMeta = getMeta({
      title: this.$t('meta.ssr_features.services.analytics.title'),
      metaTitle: this.$t('meta.ssr_features.services.analytics.title'),
      description: this.$t('meta.ssr_features.services.analytics.description'),
      route: this.$route,
      i18nLocales: this.$i18n.locales,
      i18nSeo: this.$nuxtI18nSeo(),
      options: {
        gdpr: this.$store.state.auth.gdprThirdParty
      }
    })

    resultMeta.script.push({
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schemaMarkup)
    })

    return resultMeta
  }
}
</script>

<style lang="scss" scoped>
.podcast-analytics {
  &__container {
    padding-bottom: $gap * 11;
  }
}
</style>
